import serializeObject from './serialize-object'

export default serializeObject
